import { MailOpen } from "lucide-react";
import { Link } from "react-router";

import { ROUTES } from "@/app/routes";
import { useSession } from "@/core/auth/session";
import { ROLE_LABEL } from "@/core/brand/brand-context";
import { Button } from "@/ui/button";

import { useInvitations } from "./invitations.queries";

/**
 * Open invitations to another brand's team. Someone with one brand goes straight into it, so without this
 * they'd never see an invitation. Nothing shows while loading or when there are none.
 */
export function InvitationsNotice() {
  const { me } = useSession();
  const invitations = useInvitations(Boolean(me?.email && me.emailVerified));
  const open = invitations.data ?? [];
  if (open.length === 0) return null;
  const first = open[0]!;

  return (
    <div
      role="status"
      className="flex flex-wrap items-center gap-x-4 gap-y-3 rounded-2xl border border-info/25 bg-info-soft px-4 py-3 text-sm text-ink sm:px-5"
    >
      <span className="flex min-w-0 grow items-center gap-3">
        <MailOpen className="size-5 shrink-0 text-info" aria-hidden="true" />
        {open.length === 1 ? (
          <span>
            You're invited to join <strong>{first.brandName}</strong> as {ROLE_LABEL[first.role]}.
          </span>
        ) : (
          <span>
            You're invited to join <strong>{open.length} brand teams</strong>.
          </span>
        )}
      </span>
      <Button asChild variant="secondary" size="sm">
        <Link to={ROUTES.invitations} className="no-underline">
          {open.length === 1 ? "See invitation" : "See invitations"}
        </Link>
      </Button>
    </div>
  );
}
